export const stringify = (value?: unknown, space: number = 2) => {
  if (!value) return undefined;
  try {
    return JSON.stringify(value, null, space);
  } catch {
    return undefined;
  }
};
